<!-- When sidebar is hidden, keep content in DOM so modal can use it when "Show filters" is clicked -->
@if (!visible && !showSkeleton) {
  <div #contentContainer class="fui-sidebar-filter-content-placeholder">
    <ng-content></ng-content>
  </div>
}

<!-- Desktop Sidebar -->
@if (visible) {
  <div class="fui-sidebar-filter sticky" [class.skinnier]="skinnier" [class.in-menu]="inMenu" [ngClass]="extraClasses">
    <!-- Skeleton Loader -->
    @if (showSkeleton) {
      <myp-skeleton-loader
        [type]="skeletonConfig?.type || 'line'"
        [number]="skeletonConfig?.number"
        [extraContainerClass]="skeletonConfig?.extraContainerClass || 'm-y-30'"
        [useRandomWidth]="skeletonConfig?.useRandomWidth"
        [height]="skeletonConfig?.height"
      ></myp-skeleton-loader>
    }

    <!-- Content via ng-content projection -->
    @if (!showSkeleton) {
      <div #contentContainer>
        <ng-content></ng-content>
      </div>
    }

    <!-- Hide Button -->
    @if (showHideButton) {
      <button class="small-btn m-t-30" (click)="onHideClick()">
        <fa-icon [icon]="hideButtonIcon"></fa-icon>
        {{ hideButtonText }}
      </button>
    }
  </div>
}

<!-- Mobile Modal Template -->
<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <div class="fui-sidebar-filter-mobile-content">
      <!-- Skeleton Loader -->
      @if (showSkeleton) {
        <myp-skeleton-loader
          [type]="skeletonConfig?.type || 'line'"
          [number]="skeletonConfig?.number"
          [extraContainerClass]="skeletonConfig?.extraContainerClass || 'm-y-30'"
          [useRandomWidth]="skeletonConfig?.useRandomWidth"
          [height]="skeletonConfig?.height"
        ></myp-skeleton-loader>
      }

      <!-- Content container (content will be moved here from desktop when modal opens) -->
      @if (!showSkeleton) {
        <div id="mobileContentContainer"></div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <div class="fui-sidebar-filter-mobile-footer">
      <button class="btn btn-primary" (click)="modal.close()">{{ "done" | translate }}</button>
    </div>
  </div>
</ng-template>
